import React from 'react';
import { LineChart } from '../element/chart/line-chart';
const ContentBlockService = (props)=> {
    return (
        <section className={props.padding ? props.padding : "p-top-110 p-bottom-110"}>
            <div className="container">
                <div className="row">
                    <div className="col-lg-5 margin-md-60">
                        <div className="divider text-left">
                            <h1 className="color-dark">Services Overview</h1>
                            <p></p>
                        </div>
                        <p>Investiga tiones demonstr averunt lectores legere me lius quod ii qua legunt saepius. Claritas est etiam pro cessus dynamicus, qui sequitur mutationem consuetudium.</p>
                        <div className="m-top-30">
                            <ul className="bullet--list1">
                                <li className="bullet_list"><strong className="color-dark">Professional -</strong> Delivers solutions that help drive</li>
                                <li className="bullet_list"><strong className="color-dark">Business -</strong> Human capital research analytics</li>
                                <li className="bullet_list"><strong className="color-dark">Services -</strong> Complex problems bringing an approach</li>
                                <li className="bullet_list"><strong className="color-dark">Strategy -</strong> Works with senior executives to help them</li>
                            </ul>{/*<!-- ends: .bullet--list1 -->*/}
                        </div>
                    </div>{/*<!-- ends: .col-lg-5 -->*/}
                    <div className="col-lg-6 offset-lg-1">
                        <LineChart />
                    </div>{/*<!-- ends: .col-lg-6 -->*/}
                </div>
            </div>
        </section>
    )
}
export default ContentBlockService;